import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import RefundPolicyContent from '../components/RefundPolicyContent'; 
import axios from 'axios'; 

import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
 
class RefundPolicy extends React.Component{

    constructor(){
        super(); 
    }
 
    render()
    {
       
        return (
            <div className="page-wrapper">
                <Header/> 
                <PageHeader title="Refund Policy"/>
                <RefundPolicyContent/>  
                <Footer/>
            </div>
       
        )
    }

}
export default RefundPolicy;